import { Alert, AlertTitle, Typography } from '@mui/material';
import { formatNumber, NumberFormatPreset, useCurrency } from '@procureai/ui-mui';
import { isNotNil } from 'ramda';
import { useTranslation } from 'react-i18next';

import { DetailStatusProps, manualReviewStatus } from '../NegotiationCaseDetailStatusWidget.types';
import { I18nNamespace } from '~/common/types';
import { Multiline } from '~/components/Multiline';
import { useSupplierComment } from '~/hooks';

const formatPercent = formatNumber(NumberFormatPreset.PERCENT_DECIMAL);

export const ManualReviewStatus = ({ negotiationCaseStatus, negotiatedQuote }: DetailStatusProps) => {
  const { format: formatCurrency } = useCurrency();
  const { t } = useTranslation(I18nNamespace.widgets, { keyPrefix: 'NegotiationCaseDetailStatusWidget' });

  const discountPercentage: string = negotiatedQuote ? formatPercent((negotiatedQuote.discount as number) ?? 0) : '';
  const supplierComment = negotiatedQuote?.supplierComment;
  const { format } = useSupplierComment();

  if (manualReviewStatus.includes(negotiationCaseStatus)) {
    return (
      <Alert severity="warning">
        <AlertTitle>{t('manualReview.title')}</AlertTitle>
        <>
          <Typography variant="body2">
            {t('manualReview.agreeableDiscount', {
              discount: discountPercentage,
              price: formatCurrency(negotiatedQuote?.totalPriceDiscount || 0),
            })}
          </Typography>
          {isNotNil(supplierComment) && (
            <Typography variant="body2">
              <Multiline>
                {t('manualReview.comment', {
                  comment: format(supplierComment),
                })}
              </Multiline>
            </Typography>
          )}
        </>
      </Alert>
    );
  }

  return null;
};
